import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { db, firebase } from "@/firebase/firebaseConfig.js";
import { HtmlUtil } from "@/utils"
import EcoShipMixin from "@/mixins/addon/eco-ship/EcoShipMixin.js"

const ecoShipChannelApi = AiseaApiFactory.get("ecoShipChannel");
const enterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
const ecoShipContainerCustomerMasterApi = AiseaApiFactory.get("ecoShipContainerCustomerMaster");
const ecoShipVesselContainersApi = AiseaApiFactory.get("ecoShipVesselContainers");
const epVesselDisplayChannelApi = AiseaApiFactory.get("enterpriseVesselDisplayChannel");
const ecoShipFuelConsumptionApi = AiseaApiFactory.get("ecoShipFuelConsumptions");
const ecoShipMonthlyFuelReportApi = AiseaApiFactory.get("ecoShipMonthlyFuelReport");
const ecoShipYearlyFuelReportApi = AiseaApiFactory.get("ecoShipYearlyFuelReport");

export default {

  async fetchVessels() {
    let payload = {
      is_disabled: false,
      is_deleted: false,
      page: 0,
      limit: 200
    };
    let res = await enterpriseVesselApi.search(payload);
    return res.data;
  },

  /*=========================================================================================
  チャンネルマスタAPI
  ==========================================================================================*/
  async setVersionState({ commit }, payload) {
    let res = await ecoShipChannelApi.getChannelVersions(payload.vessel_id, payload.params)
    commit("SET_VERSION_ID", { kind: payload.params.kind, version_id: res.data.version_id, version_name: res.data.version_name })
    return res.data;
  },

  async getChannelMaster(_, payload) {
    let res = await ecoShipChannelApi.getChannels(payload.vessel_id, payload.params)
    return res.data;
  },

  // async setVersionState({ commit }, payload) {
  //   let res = await ecoShipChannelApi.getChannelVersions(payload.vessel_id, payload.params)
  //   commit("SET_VERSION_ID", { kind: payload.params.kind, version_id: res.data.version_id, version_name: res.data.version_name })
  // },
  async getVersion(_, payload) {
    let res = await ecoShipChannelApi.getChannelVersions(payload.vessel_id, payload.params)
    return res.data
  },

  /*=========================================================================================
  液面管理API
  ==========================================================================================*/
  async fetchLevelGaugeDashboard({ commit }, payload) {

    let dataList = {};

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .get().then(snapshot => {
        let data = {}
        snapshot.forEach(doc => {
          let keyName = doc.id
          data[keyName] = doc.data()
        })
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["itemList"] = fetchPayload;
      });

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("trim")
      .collection("data")
      .get().then(snapshot => {
        let data = {}
        snapshot.forEach(doc => {
          let keyName = doc.id
          data[keyName] = doc.data()
        })
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["trimList"] = fetchPayload;
      });

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("heel")
      .collection("data")
      .get().then(snapshot => {
        let data = {}
        snapshot.forEach(doc => {
          let keyName = doc.id
          data[keyName] = doc.data()
        })
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["heelList"] = fetchPayload;
      });

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("fuels")
      .collection("data")
      .get().then(snapshot => {
        let data = []
        snapshot.forEach(doc => {
          data.push(doc.data());
        });
        data.sort(function(a, b) {
          const sortA = a.sort;
          const sortB = b.sort;
          if (sortA < sortB) {
            return -1;
          }
          if (sortA > sortB) {
            return 1;
          }
          return 0;
        });
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["fuelsList"] = fetchPayload;
      });

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("pure_water")
      .collection("data")
      .get().then(snapshot => {
        let data = []
        snapshot.forEach(doc => {
          data.push(doc.data());
        });
        data.sort(function(a, b) {
          const sortA = a.sort;
          const sortB = b.sort;
          if (sortA < sortB) {
            return -1;
          }
          if (sortA > sortB) {
            return 1;
          }
          return 0;
        });
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["pureWaterList"] = fetchPayload;
      });

     await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("ballast")
      .collection("data")
      .get().then(snapshot => {
        let data = []
        snapshot.forEach(doc => {
          data.push(doc.data());
        })
        data.sort(function(a, b) {
          const sortA = a.sort;
          const sortB = b.sort;
          if (sortA < sortB) {
            return -1;
          }
          if (sortA > sortB) {
            return 1;
          }
          return 0;
        });
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["ballastList"] = fetchPayload;
      });

    await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("lost")
      .collection("data")
      .get().then(snapshot => {
        let data = []
        snapshot.forEach(doc => {
          data.push(doc.data());
        });
        data.sort(function(a, b) {
          const sortA = a.sort;
          const sortB = b.sort;
          if (sortA < sortB) {
            return -1;
          }
          if (sortA > sortB) {
            return 1;
          }
          return 0;
        });
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dataList["lostList"] = fetchPayload;
      });
      commit("SET_LEVEL_GAUGE_DASHBOARD", dataList);

      return dataList;
  },

  async getLostData({ commit, dispatch }, payload) {

    const unsubscribe = await db
      .collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("lost")
      .collection("data")
      .onSnapshot(snapshot => {
        let data = []
        snapshot.docChanges().forEach(diff => {
          data.push(diff.doc.data());
        });
        data.sort(function(a, b) {
          const sortA = a.sort;
          const sortB = b.sort;
          if (sortA < sortB) {
            return -1;
          }
          if (sortA > sortB) {
            return 1;
          }
          return 0;
        });
        let fetchPayload = {
          vesselId: payload.vessel_id,
          data: data
        }
        dispatch("fetchLostData", fetchPayload);
      });
      commit("ADD_FIRESTORE_SUBSCRIBE_LIST", unsubscribe);
  },

  async fetchLostData({ commit }, payload) {
    commit("SET_LOST_DATA", payload)
  },

  async getVesselChannelData({ commit, dispatch, state }, payload) {

      let data = state.levelGauge;
      const unsubscribe = await db
        .collection("vessel_channel_data")
        .doc("v_" + payload.vessel_id)
        .collection("level_gauge")
        .doc(payload.name)
        .collection("data")
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(diff => {
            let keyName = diff.doc.data().ch
            data[keyName] = diff.doc.data()
          })
          let fetchPayload = {
            vesselId: payload.vessel_id,
            data: data
          }
          dispatch("fetchLevelGaugeFromFireStore", fetchPayload)
        })
        commit("ADD_FIRESTORE_SUBSCRIBE_LIST", unsubscribe);
  },

  async fetchLevelGaugeFromFireStore({ commit }, payload) {
    commit("SET_LEVEL_GAUGE", payload)
  },

  async updateLostFireStore(_, payload) {

    const docRef = await db.collection("enterprise_vessel_dashboard")
      .doc("e:" + payload.enterprise_id)
      .collection("v:" + payload.vessel_id)
      .doc("level_gauge")
      .collection("data")
      .doc("lost")
      .collection("data");

    await docRef.get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        if(doc.data().label === "廃油") {
          payload["wasteOilValueId"] = doc.id;
        } else if(doc.data().label === "潤滑油") {
          payload["lubricatingOilValueId"] = doc.id;
        }
      })
    });

    docRef.doc(payload.wasteOilValueId).update({
      'kg.value': payload.wasteOilValue,
      'kg.timestamp': firebase.firestore.FieldValue.serverTimestamp(),
      'weight.value': payload.wasteOilWeight,
      'weight.timestamp': firebase.firestore.FieldValue.serverTimestamp()
    });
    docRef.doc(payload.lubricatingOilValueId).update({
      'kg.value': payload.lubricatingOilValue,
      'kg.timestamp': firebase.firestore.FieldValue.serverTimestamp(),
      'weight.value': payload.lubricatingOilWeight,
      'weight.timestamp': firebase.firestore.FieldValue.serverTimestamp()
    });

  },

  /*=========================================================================================
  コンテナ顧客管理API
  ==========================================================================================*/
  async fetchContainerCustomers(_, payload) {
    let res = await ecoShipContainerCustomerMasterApi.fetch(payload);
    return res.data;
  },
  async fetchContainerCustomerDetail(_, payload) {
    let res = await ecoShipContainerCustomerMasterApi.fetchDetail(payload.id);
    return res.data;
  },
  async insertContainerCustomer(_, payload) {
    await ecoShipContainerCustomerMasterApi.add(payload.body).then(res => {
      if (!res || !res.status) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async updateContainerCustomer(_, payload) {
    await ecoShipContainerCustomerMasterApi.update(payload.id, payload.body).then(res => {
      if (!res || !res.status) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async deleteContainerCustomer(_, payload) {
    let res = await ecoShipContainerCustomerMasterApi.delete(payload.id);
    return res.data;
  },
  async fetchContainerCustomerSummary(_, payload) {
    let res = await ecoShipContainerCustomerMasterApi.getSummary(payload);
    return res.data;
  },
  async updateContainerCustomerOrders(_, payload) {
    let res = await ecoShipContainerCustomerMasterApi.updateSortOrder(payload.body);
    return res.data;
  },

  /*=========================================================================================
  コンテナ詳細情報API
  ==========================================================================================*/
  async setEnterpriseVesselsWithContainers({ commit }, payload) {
    commit("SET_ENTERPRISE_VESSELS_WITH_CONTAINERS", payload)
  },
  async fetchVesselContainers(_, payload) {
    let res = await ecoShipVesselContainersApi.fetch(payload.id);
    return res.data;
  },
  async updateVesselContainers(_, payload) {
    await ecoShipVesselContainersApi.update(payload.id, payload.container_id, payload.body).then(res => {
      if (!res || !res.status) {
        throw res
      } else {
        return res.data
      }
    })
  },
  async deleteVesselContainers(_, payload) {
    let res = await ecoShipVesselContainersApi.delete(payload.id, payload.container_id);
    return res.data;
  },

  /**
   * firestoreをリッスン.
   *
   */
  async getHanasysExpartData({ commit, dispatch }, payload) {

    //console.debug("###2496 firestore path = ", "/vessel_channel_data/v_" + payload.vessel_id + "/hanasys_expert/" + payload.version_name + "/data/");

    let unsubscribe = await db.collection("vessel_channel_data")
      .doc("v_" + payload.vessel_id)
      .collection("hanasys_expert")
      .doc(payload.version_name)
      .collection("data")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(diff => {
          if ( payload.containerChannelIdList.includes(diff.doc.id) ) {
            let fetchPayload = {
              id: diff.doc.id,
              data: diff.doc.data()
            }
            dispatch("fetchHanasysExpertFromFireStore", fetchPayload);
          }
        })
      })
    commit("ADD_FIRESTORE_SUBSCRIBE_LIST", unsubscribe);
  },
  async fetchHanasysExpertFromFireStore({ commit }, payload) {
    commit("SET_HANASYS_EXPERT", payload)
  },

  /**
   *
   */
  getStatusFromFirestore({ state }, payload ) {

    const channelData = state.hanasysExpert[payload.channel_id] ? state.hanasysExpert[payload.channel_id] : {};
    const properties = channelData.properties ? JSON.parse(channelData.properties) : {};
    const tag_status = properties.tag_status;
    const vs = channelData.vs;

    let channel_status = '';
    if (tag_status === "I") {
      channel_status = "interlock";
      if (vs === "NO-VOLT") {
        channel_status = "power-off";
      }
    } else if (tag_status === "A") {
      channel_status = "alert";
    } else if (vs === 'RUN') {
      channel_status = "active";
    } else {
      channel_status = "UNKNOWN";
    }

    return {
      channel_status: channel_status,
    };
  },

  /**
   *
   */
  async getVesselContainers({ dispatch }, vessel ){

    // その enterprise_vessel_id が ChannelOrigins情報を持っているか確認
    const resOrigins = await epVesselDisplayChannelApi.getChannelOrigins(vessel.enterprise_vessel_id);
    if ( !resOrigins.data || resOrigins.data.channel_origins.length == 0 ) {
      return null;
    }

    // kind, origin からバージョンIDとname取得
    let payloadForVersion = {
      vessel_id: vessel.id,
      params: {
        kind: "hanasys_expert",
        origin: "1",
      },
    };
    let res = await dispatch("getVersion", payloadForVersion);
    if ( ! res.version_name ) {
      return null;
    }
    const versionName = res.version_name;

    // DBからコンテナ関連のチャンネルを全取得 ( /channels/ から取得。 チャンネルの基本情報 )
    const payloadForChannelData = {
      vessel_id: vessel.id,
      params: {
        version_id: res.version_id,
        category2_id: "32", // リーファーコンテナは32固定
      },
    };
    res = await dispatch("getChannelMaster", payloadForChannelData);
    const channels = res.channels;


    // コンテナ詳細一覧取得 ( API(/containers)から取得。 コンテナの固定情報 )
    const payloadForContainers = {
      id: vessel.enterprise_vessel_id,
    };
    res = await dispatch("fetchVesselContainers", payloadForContainers);
    const enterprise_vessel_containers = res.enterprise_vessel_containers;  // コンテナカードリストとして一覧表示. （軸）


    // Firestoreのリッスン対象となるコンテナチャンネルIDをリストアップ
    let containerChannelIdList = res.enterprise_vessel_containers.map(container => container.channel_id);
    // 主要電源のchannelIdも別途取得して Firestoreリッスン対象に追加
    const rootPowerChannel = channels.find((channel) => EcoShipMixin.methods.isPowerChannel(channel));
    containerChannelIdList.push(rootPowerChannel.channel_id);

    // Firestoreのリッスン開始
    const payloadForFirestore = {
      vessel_id: vessel.id,
      version_name: versionName,
      containerChannelIdList: containerChannelIdList,
    };
    dispatch("getHanasysExpartData", payloadForFirestore);

    return {
      channels: channels,
      enterprise_vessel_containers: enterprise_vessel_containers,
    };
  },


  // unsubscribe
  async unsubscribeFirestore({ commit }) {
    commit("UNSUBSCRIBE_FIRESTORE");
  },
  /*=========================================================================================
  燃料消費量API
  ==========================================================================================*/
  async setVoyageHistoryDetail({ commit }, payload) {
    commit("SET_VOYAGE_HISTORY_DETAIL", payload);
  },

  /**
   * 航海記録情報取得API
   */
  async fetchVoyageHistoryDetail(_, payload) {
    let res = await ecoShipFuelConsumptionApi.fetchVoyageHistoryDetail(payload);
    let voyageHistoryRes = res.data;

    if (voyageHistoryRes.properties) {
      let escape = HtmlUtil.htmlEscape(voyageHistoryRes.properties);
      let properties = JSON.parse(escape);
      voyageHistoryRes.properties = properties;
    }

    return voyageHistoryRes;
  },

  /**
   * 法人船舶別動静レポート一覧取得API
   */
   async fetchReports(_, payload) {
    let res = await ecoShipFuelConsumptionApi.fetchReports(payload);
    return res.data;
  },

  /**
  * 燃焼消費月次レポート取得API
  */
  async monthlyFuelReport(_, payload) {
    let resReport = await ecoShipMonthlyFuelReportApi.report(payload);
    return resReport;
  },

  /**
  * 燃焼消費統計レポート取得API
  */
  async yearlyFuelReport(_, payload) {
    let resReport = await ecoShipYearlyFuelReportApi.report(payload);
    return resReport;
  },

}
